module.exports = __webpack_public_path__ + "img/66.f8f0962f.webp";